import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import { Cast, bool, isElementDOMNode, NodeExtension } from '@remirror/core';
import { Plugin } from 'prosemirror-state';
import { EMPTY_CSS_VALUE, CSS_ROTATE_PATTERN } from '@remirror/core-extensions';

var createImageExtensionPlugin = function createImageExtensionPlugin() {
  return new Plugin({
    props: {
      handleDOMEvents: {
        drop: function drop(view, e) {
          var event = Cast(e);
          var hasFiles = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length;

          if (!hasFiles || !event.dataTransfer) {
            return false;
          }

          var images = Array.from(event.dataTransfer.files).filter(function (file) {
            return /image/i.test(file.type);
          });

          if (images.length === 0) {
            return false;
          }

          var schema = view.state.schema;
          var coordinates = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
          });

          if (!coordinates) {
            return false;
          }

          event.preventDefault();
          images.forEach(function (image) {
            var reader = new FileReader();

            reader.onload = function (readerEvent) {
              var node = schema.nodes.image.create({
                src: readerEvent.target && Cast(readerEvent.target).result
              });
              var transaction = view.state.tr.insert(coordinates.pos, node);
              view.dispatch(transaction);
            };

            reader.readAsDataURL(image);
          });
          return true;
        }
      }
    }
  });
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var getAttrs = function getAttrs(extraAttrs) {
  return function (domNode) {
    var _domNode$style = domNode.style,
        cssFloat = _domNode$style.cssFloat,
        display = _domNode$style.display,
        marginTop = _domNode$style.marginTop,
        marginLeft = _domNode$style.marginLeft;
    var _domNode$style2 = domNode.style,
        width = _domNode$style2.width,
        height = _domNode$style2.height;
    var align = domNode.getAttribute('data-align') || domNode.getAttribute('align');

    if (align) {
      align = /(left|right|center)/.test(align) ? align : null;
    } else if (cssFloat === 'left' && !display) {
      align = 'left';
    } else if (cssFloat === 'right' && !display) {
      align = 'right';
    } else if (!cssFloat && display === 'block') {
      align = 'block';
    }

    width = width || domNode.getAttribute('width') || '';
    height = height || domNode.getAttribute('height') || '';
    var crop = null;
    var rotate = null;
    var parentElement = domNode.parentElement;

    if (parentElement instanceof HTMLElement) {
      // Special case for Google doc's image.
      var ps = parentElement.style;

      if (ps.display === 'inline-block' && ps.overflow === 'hidden' && ps.width && ps.height && marginLeft && !EMPTY_CSS_VALUE.has(marginLeft) && marginTop && !EMPTY_CSS_VALUE.has(marginTop)) {
        crop = {
          width: parseInt(ps.width, 10) || 0,
          height: parseInt(ps.height, 10) || 0,
          left: parseInt(marginLeft, 10) || 0,
          top: parseInt(marginTop, 10) || 0
        };
      }

      if (ps.transform) {
        // example: `rotate(1.57rad) translateZ(0px)`;
        var mm = ps.transform.match(CSS_ROTATE_PATTERN);

        if (mm && mm[1]) {
          rotate = parseFloat(mm[1]) || null;
        }
      }
    }

    return _objectSpread({}, extraAttrs, {
      align: align,
      alt: domNode.getAttribute('alt') || null,
      crop: crop,
      height: parseInt(height || '0', 10) || null,
      rotate: rotate,
      src: domNode.getAttribute('src') || null,
      title: domNode.getAttribute('title') || null,
      width: parseInt(width || '0', 10) || null
    });
  };
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var hasCursor = function hasCursor(arg) {
  return bool(Cast(arg).$cursor);
};

var ImageExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(ImageExtension, _NodeExtension);

  function ImageExtension() {
    _classCallCheck(this, ImageExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageExtension).apply(this, arguments));
  }

  _createClass(ImageExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return {
        insertImage: function insertImage(attrs) {
          return function (state, dispatch) {
            var selection = state.selection;
            var position = hasCursor(selection) ? selection.$cursor.pos : selection.$to.pos;
            var node = type.create(attrs);
            var transaction = state.tr.insert(position, node);

            if (dispatch) {
              dispatch(transaction);
            }

            return true;
          };
        }
      };
    }
  }, {
    key: "plugin",
    value: function plugin() {
      return createImageExtensionPlugin();
    }
  }, {
    key: "name",
    get: function get() {
      return 'image';
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        inline: true,
        attrs: _objectSpread$1({}, this.extraAttrs(null), {
          align: {
            default: null
          },
          alt: {
            default: ''
          },
          crop: {
            default: null
          },
          height: {
            default: null
          },
          width: {
            default: null
          },
          rotate: {
            default: null
          },
          src: {
            default: null
          },
          title: {
            default: ''
          }
        }),
        group: 'inline',
        draggable: true,
        parseDOM: [{
          tag: 'img[src]',
          getAttrs: function getAttrs$1(domNode) {
            return isElementDOMNode(domNode) ? getAttrs(_this.getExtraAttrs(domNode)) : {};
          }
        }],
        toDOM: function toDOM(node) {
          return ['img', node.attrs];
        }
      };
    }
  }]);

  return ImageExtension;
}(NodeExtension);

export { ImageExtension };
//# sourceMappingURL=extension-image.esm.js.map
